import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom'

import PropTypes from "prop-types";

import axios from 'axios'
import firebase, { db, sendEmail, storage } from "firebase/fbConfig.js"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/CreateCaseFormStyle.jsx";
import ExploreAssignUser from "../../views/Explore/ExploreAssignUser";

class Form extends React.Component {
    state = {
        comment: '',
        messageSent: false,
        messageError: false
    }
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            fields: ['description', 'price', 'address'],
            data: ""
        };
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }
    handleFieldChange = (e) => {
        this.setState({
                [e.target.id]: e.target.value,
        })
        console.log(this.state)
    }
    handleChange = (e) => {
        this.setState({
            data: {
                [e.target.id]: e.target.value,
                ...this.state.data
            }
        })
        console.log(this.state)
    }
    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
        console.log(this.state)
    }
    handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result,
                imageChanged: true
            });
        };
        reader.readAsDataURL(file);
    }


    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.props)
        // update firestore document with PENDING and comment
        db.collection(this.props.title).add({
            createdDate: new Date(),
            ...this.state.data
        }).then((docRef) => {
            window.location.reload()
        }).catch((err) => {
            console.log(`${err}`)
        })
    }


    resetRequest = () => {
        // window.location.reload();
    }

    continueForm = () => {

        this.setState({
            continueForm: true,
        })

    }

    editForm = () => {

        this.setState({
            editForm: true,
        })

    }

    addNewField = (field) => {
        console.log(this.state.fields)
        var array = [field]
        var list = this.state.fields.concat(array)
        var name = this.state.data.newFieldName
        console.log(list)
        this.setState({
            fields: list,
            [name]: ''
        })
    }

    assignClient = (clientID, firstName, lastName, email) => {
        this.setState({
            clientID: clientID,
            clientFirstName: firstName,
            clientLastName: lastName,
            clientEmail: email
        })
    }

    requestSignature = () => {
        const axios = require("axios");
      
        axios({
          "method": "POST",
          "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
          "data": {
            "sandbox": 0,
            "is_draft": 0,
            "embedded": 1,
            "title": `Haney Freightways Document House Waybill #${this.props.orderID}`,
            "message": "This is my general document message.",
            "use_signer_order": 0,
            "reminders": 1,
            "require_all_signers": 1,
            "custom_requester_name": "",
            "custom_requester_email": "",
            "redirect": "",
            "redirect_decline": "",
            "client": "",
            "expires": 1750513480,
            "embedded_signing_enabled": 1,
            "flexible_signing": 0,
            "use_hidden_tags": 0,
            "files": [{
              "name": "House Waybill",
              "file_url": "https://firebasestorage.googleapis.com/v0/b/ltr-app.appspot.com/o/agreements%2F2020-02-27%20PONDATA%20MASTER%20SERVICES%20AGREEMENT%20(2020-02)FINAL.docx.pdf?alt=media&token=0f3244d1-d6c8-4047-bbfb-cf00b63bd928",
              "file_id": "",
              "file_base64": ""
            }],
            "signers": [{
              "id": 1,
              "name": "Marc",
              "email": "justin@maren-go.com",
              "order": 1,
              // "pin": "3874",
              "message": "This is my custom message to Shipper.",
              "deliver_email": 0,
              "language": "en"
            }, {
              "id": 2,
              // "name": (this.state.driversDropOffData[0].firstName + this.state.driversDropOffData[0].firstName),
              "name": "Driver Signer",
              "email": "justin@pondata.com",
              "order": 2,
              // "pin": "3874",
              "message": "This is my custom message to Driver.",
              "deliver_email": 0,
              "language": "en"
            }],
            "recipients": [{
              "name": "Justin",
              "email": "development@kordspace.com",
              "language": "en"
            }],
            "meta": {
              "some_key": "some_value",
              "another_key": "another_value"
            },
            "fields": [
              [{
                "type": "signature",
                "x": "520",
                "y": "930",
                "width": "120",
                "height": "35",
                "page": "1",
                "signer": "1",
                "name": "",
                "identifier": "unique_field_identifier_1",
                "required": 1,
                "readonly": 0,
                "validation_type": "",
                "text_size": "",
                "text_color": "",
                "text_font": "",
                "text_style": "",
                "value": "",
                "options": [],
                "group": ""
              },{
                "type": "signature",
                "x": "50",
                "y": "995",
                "width": "120",
                "height": "35",
                "page": "1",
                "signer": "2",
                "name": "",
                "identifier": "unique_field_identifier_2",
                "required": 1,
                "readonly": 0,
                "validation_type": "",
                "text_size": "",
                "text_color": "",
                "text_font": "",
                "text_style": "",
                "value": "",
                "options": [],
                "group": ""
              }]
            ]
          }
          // "params": {
          //   "withFlightInfoOnly": "false"
          // }
        })
        .then((response) => {
          console.log(response);
          this.setState({
            signingURL: response.data.signers[0].embedded_signing_url,
            signingURL1: response.data.signers[0].embedded_signing_url,
            signingURL2: response.data.signers[1].embedded_signing_url,
            signatureURLLoaded: true,
          })
        }, (error) => {
          console.log(error);
        }).then(async () => {
          console.log(this.state.orderData.origin.email)
          //const email = this.props.user.email
  
          let subject = `LTR Contract`
          let html = `<p>Thanks again for choosing Haney Freightways!</p>`
          html += `<a href="${this.state.signingURL1}">Review & Sign Here</a>`
          html += `<a href="${this.state.signingURL2}">Review & Sign Here</a>`
          // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
          const emails = [this.state.orderData.origin.email]
          const attatchment = true;
          const emailReturn = await sendEmail({
            emails,
            subject,
            html,
            attatchment
          })
      
        }).then(() => {
          window.location.reload()
        })
    

    }


    render() {
        const { classes, modalClose, authUser, user, title, blogID } = this.props;
        console.log(this.state)


        // reset modal when closed
        // if (this.state.messageSent) { this.resetRequest() }
        const states = ['Oregon', 'Washington', 'Colorado', 'Wyoming']
        const caseTypes = ['Criminal', 'Civil', 'Family']
        const serviceTypes = ['Document Preparation', 'Representation', 'Counsel']
        const dataTypes = ['string', 'number']

        return (
            <div>
                
            </div>
        );
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(Form);


// WEBPACK FOOTER //
// ./src/components/Forms/RequestSignature.jsx